module.exports = __webpack_public_path__ + "img/guankongmoshi.6b19fb6a.png";